import styled from 'styled-components';

import type { Props as ButtonProps } from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { useIsTabletAndAbove } from '#src/hooks/device/useIsTabletAndAbove.ts';

const StyledButton = styled(Button)`
  &.medium,
  &.large {
    min-width: 240px;
  }
`;

export const OnboardingButton = ({
  loading,
  ...otherProps
}: Omit<ButtonProps, 'loading'> & {
  loading?: boolean;
}) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  return (
    <StyledButton
      {...otherProps}
      fullWidth={!isTabletAndAbove}
      loading={!!loading}
    />
  );
};
